import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-secondary-900 text-white">
      <div className="container py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* Company Info */}
          <div>
            <h3 className="mb-4 text-xl font-bold">FutureSoft</h3>
            <p className="mb-4 text-secondary-300">
              Transforming ideas into innovative software solutions that drive business growth and enhance user experiences.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-secondary-300 hover:text-primary-400">
                <FaFacebook size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-secondary-300 hover:text-primary-400">
                <FaTwitter size={20} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-secondary-300 hover:text-primary-400">
                <FaLinkedin size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-secondary-300 hover:text-primary-400">
                <FaInstagram size={20} />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="mb-4 text-xl font-bold">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-secondary-300 hover:text-primary-400">Home</Link></li>
              <li><Link to="/about" className="text-secondary-300 hover:text-primary-400">About Us</Link></li>
              <li><Link to="/services" className="text-secondary-300 hover:text-primary-400">Services</Link></li>
              <li><Link to="/portfolio" className="text-secondary-300 hover:text-primary-400">Portfolio</Link></li>
              <li><Link to="/contact" className="text-secondary-300 hover:text-primary-400">Contact</Link></li>
            </ul>
          </div>
          
          {/* Services */}
          <div>
            <h3 className="mb-4 text-xl font-bold">Our Services</h3>
            <ul className="space-y-2">
              <li><Link to="/services" className="text-secondary-300 hover:text-primary-400">Web Development</Link></li>
              <li><Link to="/services" className="text-secondary-300 hover:text-primary-400">Mobile App Development</Link></li>
              <li><Link to="/services" className="text-secondary-300 hover:text-primary-400">Enterprise Solutions</Link></li>
              <li><Link to="/services" className="text-secondary-300 hover:text-primary-400">Custom Software</Link></li>
              <li><Link to="/services" className="text-secondary-300 hover:text-primary-400">UI/UX Design</Link></li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h3 className="mb-4 text-xl font-bold">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <FaMapMarkerAlt className="mt-1 mr-3 text-primary-400" />
                <span className="text-secondary-300">12, Block C8, 1st Floor, Sector 18 , Vrindavan yojna, Lucknow, Uttar Pradesh</span>
              </li>
              <li className="flex items-center">
                <FaPhone className="mr-3 text-primary-400" />
                <span className="text-secondary-300">+91 9455544334</span>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="mr-3 text-primary-400" />
                <span className="text-secondary-300">info@futuresoft.tech</span>
              </li>
            </ul>
          </div>
        </div>
        
        <hr className="my-8 border-secondary-700" />
        
        <div className="flex flex-col items-center justify-between md:flex-row">
          <p className="text-secondary-400">
            &copy; {currentYear} FutureSoft Technologies. All rights reserved.
          </p>
          <div className="mt-4 space-x-4 md:mt-0">
            <Link to="/privacy-policy" className="text-secondary-400 hover:text-primary-400">Privacy Policy</Link>
            <Link to="/terms-of-service" className="text-secondary-400 hover:text-primary-400">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
